var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define('tracks/trimmer',["require", "exports", "../util/http", "./track-state", "./trackdata-processing"], function (require, exports, http_1, trackState, trackdata_processing_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Trimmer = void 0;
    var Trimmer = /** @class */ (function () {
        function Trimmer(track) {
            this.dragging = false;
            this.bisectDate = d3.bisector(function (d) { return d.millis; }).left;
            this.track = track;
            this.active = __assign({}, track.trim);
        }
        // Save the trim to the server
        Trimmer.prototype.saveTrim = function () {
            this.trimTrim(this.active);
            // Check if trim has changed
            if (this.active.min === this.track.trim.min && this.active.max === this.track.trim.max) {
                return;
            }
            // Save official trim
            this.track.trim = __assign({}, this.active);
            // Post to baseline server
            (0, http_1.postJson)("/tracks/" + this.track.track_id + "/trim", this.active);
            // Recompute track data
            (0, trackdata_processing_1.processData)(this.track);
            // Notify listeners
            trackState.trimUpdates.post(undefined);
        };
        // Return a tight bound on the active trim
        Trimmer.prototype.tightTrim = function () {
            // Copy active
            var tight = { min: this.active.min, max: this.active.max };
            // Trim it
            this.trimTrim(tight);
            return tight;
        };
        // Trim a given trim to be tight around the data
        Trimmer.prototype.trimTrim = function (trim) {
            if (trim.min === undefined || trim.max === undefined)
                return;
            // Ensure that min <= max
            if (trim.max < trim.min) {
                var temp = trim.min;
                trim.min = trim.max;
                trim.max = temp;
            }
            // Trim must be at least 1 second
            if (trim.max - trim.min >= 1000) {
                // Find inner points
                var startIndex = this.bisectDate(this.track.data, trim.min);
                var startPoint = this.track.data[startIndex];
                var endIndex = this.bisectDate(this.track.data, trim.max) - 1;
                var endPoint = this.track.data[endIndex];
                if (startPoint && endPoint) {
                    trim.min = startPoint.millis;
                    trim.max = endPoint.millis;
                }
            }
            else {
                trim.min = undefined;
                trim.max = undefined;
            }
        };
        return Trimmer;
    }());
    exports.Trimmer = Trimmer;
});
//# sourceMappingURL=/assets/javascripts/tracks/trimmer.js.map;
